/**
 * Estimated combat value per ammo unit, used by the balance tool to
 * score loadouts (ammo × score) and by itemReferencePrices to derive
 * shop prices.
 *
 * Anything not listed here is treated as 0 / "no commercial power".
 *
 * How to tune these values: Roughly the units are "how many squids one shot can kill reliably playing well"
 * example 1 cannon shot = 1 squid killed
 */
export const WEAPON_POWER: Record<string, number> = {
	Cannon: 1,
	CannonBurst: 3,
	MissileGun: 5,
	MissileBurst: 8,
	PlasmaGun: 4,
	DrillLauncher: 4,
	Flamethrower: 6,
	GasBombWeapon: 5,
	LaserGun: 4,
	LandmineWeapon: 1.5,
	// starter weapons with infinite ammo
	CryoGun: 0,
	AirBlast: 0,
	Solidifier: 0,
	TripleSolidifier: 0,
	// Utility / non-offensive
	BarrierGun: 2,
	Jetpack: 10,
	// Collectable items (Key/Medikit) are scanned alongside weapons by the loot
	// tool but contribute 0 power.
	Key: 0,
	Medikit: 0,
	// Dev / cheat weapons
	DevGunAutoKill: 0,
	OpGun: 0,
	OpGun2: 0,
	OpGunNuke: 0,
	BlackHoleGun: 0,
};
